import DashboardChartRangeFilter from "./DashboardChartRangeFilter";

export default DashboardChartRangeFilter;
